import React from 'react';
import { EVBarriersMetrics, IncomeQuintile } from '../../services/evAdoptionBarriersService';
import { KeyMetrics, KeyMetric } from './KeyMetrics';

interface EVBarriersMetricsProps {
  metrics: EVBarriersMetrics;
  quintiles: IncomeQuintile[];
}

const EVBarriersMetricsComponent: React.FC<EVBarriersMetricsProps> = ({ metrics, quintiles }) => {
  return (
    <KeyMetrics>
      <KeyMetric
        value={metrics.correlation.toFixed(3)}
        label="Correlation Coefficient (r)"
        color="#8b5cf6"
      />
      <KeyMetric
        value={`${metrics.evGap.toFixed(2)}`}
        label="EV Adoption Gap (EVs/100)"
        color="#3b82f6"
      />
      <KeyMetric
        value={`$${(metrics.quintileGap / 1000).toFixed(0)}K`}
        label="Income Gap"
        color="#10b981"
      />
      <KeyMetric
        value={metrics.sampleSize.toString()}
        label="Census Tracts Analyzed"
        color="#f59e0b"
      />
    </KeyMetrics>
  );
};

export default EVBarriersMetricsComponent;
